module.exports = __webpack_public_path__ + "static/img/2-3.c426b73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/2-3.jpg
// module id = fDXj
// module chunks = 25